@if (item()) {
    <div class="cpw-item-details__header">
        @if (active() && !completed() && !showDescription()) {
            <cpw-item-image
                class="cpw-item-details__header-thumb"
                [itemId]="item().id!"
                [width]="40"
                [height]="40"></cpw-item-image>
        }
        <pf-chip
            class="cpw-item-details__header-item-chip"
            [pfStatus]="itemChipStatus()"
            (click)="copyItemCode()"
            >{{ item().name }} | {{ item().code }}
        </pf-chip>
        <span class="cpw-item-details__uom">
            {{ itemUom$ | async }}
            @if (quantity) {
                · {{ quantity }}
            }
        </span>
        @if (additionalChips()) {
            @for (chip of additionalChips(); track $index) {
                <pf-chip [pfStatus]="chip.status" (click)="onChipClick(chip)"
                    >{{ chip.revealed ? chip.hiddenLabel : chip.label }}
                </pf-chip>
            }
        }
    </div>

    @if (active() && !completed()) {
        @if (showDescription()) {
            <div class="cpw-item-details__description">
                <cpw-item-image [itemId]="item().id!"></cpw-item-image>
                <pf-text type="description" [ellipsis]="true" [ellipsisRows]="4"
                    >{{ item().description }}
                </pf-text>
            </div>
        }

        @if (showScans()) {
            <div class="cpw-item-details__bundle-verification">
                <ng-content select="[cpwItemDetailsScans]">
                    <cpw-picking-item-scans
                        [item]="item()"
                        [bundle]="bundle()"
                        [isLTL]="isLTL()"
                        [active]="active()"
                        [completed]="completed()"
                        [verifiedLocationScanValue]="verifiedLocationScanValue"
                        [verifiedItemScanValue]="verifiedItemScanValue"
                        (itemVerified)="
                            onDefaultItemVerified($event)
                        "></cpw-picking-item-scans>
                </ng-content>
            </div>

            @if (showBundleQuantities()) {
                <div class="cpw-item-details__bundle-info">
                    <pf-text type="info"
                        >Reserved: {{ bundleQuantities().reserved }}
                    </pf-text>
                    <pf-text type="info"
                        >Available: {{ bundleQuantities().available }}
                    </pf-text>
                </div>
            }
        }
    }
}
